export const PAYMENT_MODE_OPTIONS = [
  { id: "BankTransfer", name: "Bank Transfer" },
  { id: "Card", name: "Card" },
  { id: "Cash", name: "Cash" },
]

export const IS_PAID_OPTIONS = [
  { id: false, name: "No" },
  { id: true, name: "Yes" },
]

export const MONTH_OPTIONS = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
]

export const YEAR_OPTIONS = Array.from(
  { length: 2050 - 2020 + 1 },
  (_, i) => {
    const year = 2020 + i
    return { id: year, name: `${year}` }
  },
)
